import React from 'react';
import { Grid, Label } from 'semantic-ui-react';
import FlightDate from '../FlightDate'
import copy from 'copy-to-clipboard'
import moment from 'moment'
import "moment-duration-format"

const claimLabels = (flight, status) => {
  const delayedFlight = flight && flight.delayedFlight

  const flagLabels = []
    if (delayedFlight) {
      flagLabels.push((
        <Label size="small" key={'monitored'} onClick={() => { copy(delayedFlight.id) }}>Monitored flight</Label>
        ))
      if (delayedFlight.cancelled) {
        flagLabels.push((
          <Label key={0} color="yellow" size="small"> Cancelled </Label>
        ))
      }
      if (delayedFlight.diverted) {
        flagLabels.push((
          <Label key={1} color="yellow" size="small"> Diverted </Label>
        ))
      }
      if (delayedFlight.recovered) {
        flagLabels.push((
          <Label key={2} color="orange" size="small"> Recovered </Label>
        ))
      }
      if (delayedFlight.delayAtArrival) {
        flagLabels.push((
          <Label key={3} color="orange" size="small"> delay at arrival: {moment.duration(delayedFlight.delayAtArrival, "seconds").format()} </Label>
        ))
      }
      if (delayedFlight.localActualDepartureDate) {
        flagLabels.push((
          <Label key={4} color="red" size="small"> actual departure: <FlightDate date={delayedFlight.localActualDepartureDate} /> </Label>
        ))
      }
      if (delayedFlight.localActualArrivalDate) {
        flagLabels.push((
          <Label key={5} color="red" size="small"> actual arrival: <FlightDate date={delayedFlight.localActualArrivalDate} /> </Label>
        ))
      }
    }
    if (status === 'overbooked') {
      flagLabels.push((
        <Label key={8} color="purple" size="small"> Overbooked </Label>
      ))
    }
    if (flight.blackDay) {
      flagLabels.push((
        <Label key={10} color="black" size="small"> Blacklisted day </Label>
      ))
    }
    if (flight.crisisDateInterval) {
      flagLabels.push((
        <Label key={11} color="black" size="small"> COVID Crisis </Label>
      ))
    }
  return flagLabels
}

const ticketLabels = (flight, status) => {
  const flagLabels = claimLabels(flight, status)
  if (status === 'missed') {
    flagLabels.push((
      <Label key={9} color="teal" size="small"> Missed </Label>
    ))
  }
  
  return flagLabels
}

function FlightLabels({labels}) {
  if ( labels.length > 0) {
    return (
      <Grid.Column>
        {labels}
      </Grid.Column>
    )
  }
  return null
}

export function ClaimFlightLabels({flight, status}) {
  return (
    <FlightLabels
      status={status}
      labels={claimLabels(flight, status)}
    />
  )
}

export function TicketFlightLabels({flight, status}) {
  return (
    <FlightLabels
      status={status}
      labels={ticketLabels(flight, status)}
    />
  )
}



// WEBPACK FOOTER //
// ./src/component/FlightView/FlightLabels.js